export default "__VITE_ASSET__wkKLhnlx__"